import { useContext } from 'react';

import LoadingContext from 'layout/Loading/context/LoadingContext';

const useLoading = () => {
	return useContext(LoadingContext);
};

export default useLoading;
